export default __webpack_public_path__ + "static/media/Sig2.cd2bb0b9.png";